import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getTerms, getPrivacy } from "../api";
import { scrollToTop, tokenSolver, getImg, privGtmKey } from "../utils";
import { CoalitionSpinner, CoalitionButton } from "./../components";
import { chevron_left } from "../pngs";
import {
  sendTag,
  event_properties_105_04,
  event_properties_105_05,
} from "../components/CoalitionGtm";
import "./WildCardPage.scss";
import "./Pages.scss";

export const TermsConditionsPage = (fh = false) => {
  const gtm = localStorage.getItem(privGtmKey);
  useEffect(() => {
    if (gtm) sendTag(gtm, event_properties_105_05());
  }, [gtm]);

  const [terms, setTerms] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      setTerms(await getTerms());
      scrollToTop();
    };
    fetchData();
  }, []);

  return (
    <div className={`public-page no-top-padding ${fh ? "fh" : ""}`}>
      <GenericPage
        title="Términos y condiciones"
        buttonClicked={() => navigate(`/?${tokenSolver()}`)}
      >
        {terms}
      </GenericPage>
    </div>
  );
};

export const PrivacyPolicyPage = (fh = false) => {
  const gtm = localStorage.getItem(privGtmKey);
  useEffect(() => {
    if (gtm) sendTag(gtm, event_properties_105_04());
  }, [gtm]);

  const [priv, setPriv] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      setPriv(await getPrivacy());
      scrollToTop();
    };
    fetchData();
  }, []);

  return (
    <div className={`public-page no-top-padding ${fh ? "fh" : ""}`}>
      <GenericPage
        title="Aviso de privacidad"
        buttonClicked={() => navigate(`/?${tokenSolver()}`)}
      >
        {priv}
      </GenericPage>
    </div>
  );
};

export const GenericPage = ({ title, children, buttonClicked }) => {
  return (
    <>
      <div className="generic-page">
        <CoalitionButton
          label={title}
          klass="nav-button"
          onClickEvent={buttonClicked}
        >
          {getImg(chevron_left, "back-icon")}
        </CoalitionButton>
        {children ? (
          <pre className="content">{children}</pre>
        ) : (
          <CoalitionSpinner />
        )}
      </div>
    </>
  );
};
